'use client';

import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from 'react';

type Context = {
  errorMessage: string;
  setErrorMessage: Dispatch<SetStateAction<string>>;
};

type ErrorProps = {
  children: ReactNode;
};

export const ErrorContext = createContext<Context>(null);

export const ErrorProvider = ({ children }: ErrorProps) => {
  const [errorMessage, setErrorMessage] = useState();

  const contextValues = useMemo(
    () => ({
      errorMessage,
      setErrorMessage
    }),
    [errorMessage, setErrorMessage]
  );

  return (
    <ErrorContext.Provider value={contextValues}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useErrorContext = () => useContext(ErrorContext);
